export default "/assets/website/images/document-bg.jpeg?feacf6a526bdf1efca813932130c1f3e";